var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"flex min-w-[75px] flex-shrink-0 items-center justify-center whitespace-nowrap border text-center leading-none transition-all",class:[{ 'cursor-pointer': !_vm.static }, _setup.tagClasses],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }